import {ReportType} from '../../../types/report-type'
import {formatLojasValue} from '../lojasRelacionamento'
import {REPORT_DEFINITIONS} from './reportDefinitions'

export const ENGLISH_MONTHS =
  'January February March April May June July August September October November December'.split(' ')
export const PORTUGUESE_MONTHS =
  'Janeiro Fevereiro Março Abril Maio Junho Julho Agosto Setembro Outubro Novembro Dezembro'.split(
    ' '
  )
const ISO_DATE =
  /^(\d{4})-(\d{2})-(\d{2})(?:[ T]\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?)?$/

export function formatCalendarDate(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const match = value.match(ISO_DATE)
  return match ? `${match[3]}/${match[2]}/${match[1]}` : null
}

export function formatReportValue(type: ReportType, column: string, value: unknown): string {
  const format = REPORT_DEFINITIONS[type].format
  if (format === 'relationship') return formatLojasValue(column, value)
  if (value === null || value === undefined || value === '') return '—'
  if (
    format === 'priority' &&
    column === 'TempoTransito' &&
    (Number(value) === -1 || Number(value) === 0)
  )
    return 'Não Informado'
  const date = formatCalendarDate(value)
  if (date && (format !== 'stock' || column === 'DataPreco' || column === 'DataEstoque'))
    return date
  if (format === 'promotions') {
    const month = String(value).match(/^([A-Za-z]+)-(\d{2})$/)
    const index = month ? ENGLISH_MONTHS.indexOf(month[1]) : -1
    if (month && index >= 0) return `${PORTUGUESE_MONTHS[index]}/20${month[2]}`
    if (column === 'Quantidade' && Number.isFinite(Number(value)))
      return String(Math.trunc(Number(value)))
    if (column === 'DescontoTotal' && Number.isFinite(Number(value)))
      return String(Math.round(Number(value) * 100) / 100)
  }
  return String(value)
}
